import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from 'ngx-webstorage';
import { NotificationService } from './../../service/notification.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';

import { ClientManagementService } from './../../service/clientManagement.service';
import { ClientPageRequest } from './../../model/management-config/clientPageRequest';
import { ClientManagement } from './../../model/management-config/clientManagement';
import { AddClientComponent } from './add-client/add-client.component';
import { EditClientComponent } from './edit-client/edit-client.component';

@Component({
  selector: 'app-client-management',
  templateUrl: './client-management.component.html',
  styleUrls: ['./client-management.component.scss']
})
export class ClientManagementComponent implements OnInit {

  selectedClient: ClientManagement = new ClientManagement();
  clientManagement: ClientManagement[];
  dataSource: MatTableDataSource<ClientManagement>;
  searchKey: string = null;

  nameFilter = new FormControl();
  isEditClientDisabled: boolean = false;
  isTargetButtonDisabled: boolean = true;
  selection = new SelectionModel<ClientManagement>(true, []);
  isRadionButtonClicked: boolean = false;

  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;
  length: number;
  pageSizeOptions: number[] = [15, 30, 45];
  clientPageRequests = new ClientPageRequest();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

 displayedColumns = ['selection','clientId', 'clientName', 'clientDesc', 'createdBy', 'createdTimestamp', 'updatedBy', 'updatedTimestamp'];
 constructor(
   private clientManagementService: ClientManagementService,
   public dialog: MatDialog,
   private _localStorage: LocalStorageService,
   private router: Router) {
 }

 ngOnInit() {
  this._localStorage.store('PageEvent', undefined);
  this.isEditClientDisabled = true;
  this.getClients();
 }

 getClients(event?: PageEvent, clearPagination?: boolean) {
  if(clearPagination){
    this._localStorage.store('PageEvent', undefined);
  }
   if (event != undefined) {
    this._localStorage.store('PageEvent', event);
     this.clientPageRequests.pageNum = event.pageIndex;
     this.clientPageRequests.pageSize = event.pageSize;
   }else if (event === undefined || event === null) {
     this.clientPageRequests.pageNum = 0;
     this.clientPageRequests.pageSize = 15;
   }
   this.clientPageRequests.sortBy = "clientName";
     this.clientPageRequests.sortDir = "ASC";
   if(this.searchKey!= undefined && this.searchKey != null){
     this.clientPageRequests.searchValue = this.searchKey.toLowerCase();
   }else{
     this.clientPageRequests.searchValue = '';
   }
   this.clientManagementService.getClientList(this.clientPageRequests)
     .subscribe(result => {
       if (!result) {
         return;
       }
       console.log(result);
       this.clientManagement = result.clients;
       this.dataSource = new MatTableDataSource(result.clients);
       this.dataSource.sort = this.sort;
 
       if (event != undefined) {
         this.pageIndex = event.pageIndex;
         this.pageSize = event.pageSize;
         this.length = result.totalCount;
       }
       if (event === undefined || event === null) {
         this.pageIndex = 0;
         this.pageSize = 15;
         this.length = result.totalCount;
       }
       this.nameFilter.valueChanges.subscribe((nameFilterValue) => {
         this.dataSource.data = this.filterOptions(nameFilterValue);
       });
     }, error => console.log(error));
     return event;
 }

 openAddClientDialog(): void {
  const dialogRef = this.dialog.open(AddClientComponent, {
   panelClass: 'assign-sch-model',
   data: this.dialog
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log("result " + result);
    this.getClients(this._localStorage.retrieve('PageEvent'));
  });
  }

 openEditClientDialog(): void {
   const dialogRef = this.dialog.open(EditClientComponent, {
    panelClass: 'assign-sch-model',
     data:
       this.selectedClient
   });

   dialogRef.afterClosed().subscribe(result => {
     console.log("result " + result);
     this.getClients(this._localStorage.retrieve('PageEvent'));
     this.isEditClientDisabled = true;
   });
 }

 reset() {
   this.isTargetButtonDisabled = true;
   this.isRadionButtonClicked = false;
   this.isEditClientDisabled = true;
   this.getClients();
   this.selection.clear();
 }

//  isAllSelected() {
//    const numSelected = this.selection.selected.length;
//    const numRows = this.dataSource.data.length;
//    return numSelected === numRows;
//  }

//  toggle(row) {
//    console.log(row.firstName + "<>" + this.selection.selected.includes(row))
//    if (this.selection.selected.includes(row)) {
//      this.selection.deselect(row)
//    } else {
//      this.selection.select(row)
//    }
//    if (this.selection.selected.length > 0) {
//      this.isEditClientDisabled = false;
//      this.isTargetButtonDisabled = false;
//    } else {
//      this.isEditClientDisabled = true;
//      this.isTargetButtonDisabled = true;
//    }
//  }

//  masterToggle() {
//    this.isAllSelected() ?
//      this.selection.clear() :
//      this.dataSource.data.forEach(row => { this.selection.select(row) });
//    if (this.selection.selected.length > 0) {
//      this.isEditClientDisabled = false;
//      this.isTargetButtonDisabled = false;
//    } else {
//      this.isEditClientDisabled = true;
//      this.isTargetButtonDisabled = true;
//    }
//  }

 filterOptions(nameValue: string): ClientManagement[] {
   if (!nameValue) {
     return this.clientManagement;
   }
   const filtered = this.clientManagement.filter((element) => {
     return (nameValue ? element.clientName.toLowerCase().includes
       (nameValue.toLowerCase()) : false) || (nameValue ? element.clientName.toLowerCase().includes
         (nameValue.toLowerCase()) : false)
   });
   return filtered;
 }

//  customFilterPredicate() {
//    const myFilterPredicate = function (data: NursePractitioner, filter: string): boolean {
//      let searchString = JSON.parse(filter);
//      return data.firstName.toString().trim().toLowerCase().indexOf(searchString.name.toLowerCase()) !== -1 &&
//        data.lastName.toString().trim().toLowerCase().indexOf(searchString.name.toLowerCase()) !== -1;
//    }
//    return myFilterPredicate;
//  }

 radiobuttonClick(event, clientManagement: ClientManagement): void {
   this.isRadionButtonClicked = true;
   this.isEditClientDisabled = false;
  //  if (clientManagement.isActive) {
  //   // this.isEditClientDisabled = false;
  //  } else {
  //    //this.isEditClientDisabled = true;
  //  }
   this.selectedClient = clientManagement;
 }

 onSearchClear() {
  this.searchKey = "";
  this.getClients();
}
}